import React, { useState, useEffect } from 'react';
import TextField from '@mui/material/TextField';
import { makeStyles } from '@mui/styles';
import { useSelector, useDispatch } from "react-redux";
import Grid from '@mui/material/Grid';
import { api } from 'common';
import { useTranslation } from "react-i18next";
import { colors } from '../components/Theme/WebTheme';
import Button from "components/CustomButtons/Button.js";
import FormControlLabel from '@mui/material/FormControlLabel';
import Switch from '@mui/material/Switch';
import Typography from '@mui/material/Typography';
import { MAIN_COLOR, SECONDORY_COLOR } from "../common/sharedFunctions"

const useStyles = makeStyles(theme => ({
  '@global': {
    body: {
      backgroundColor: theme.palette.common.white,
    },
  },
  container: {
    zIndex: "12",
    color: "var(--text-main)",
    alignContent: 'center',
    width: '70%'
  },
  container1: {
    backgroundColor: 'var(--bg-card)',
    backdropFilter: 'blur(12px)',
    borderTopLeftRadius: "20px",
    borderTopRightRadius: "20px",
    borderBottomLeftRadius: "20px",
    borderBottomRightRadius: "20px",
    padding: '30px',
    width: '100%',
    top: "19px",
    boxShadow: `0 8px 24px rgba(0, 0, 0, 0.3)`,
    border: 'var(--card-border)',
  },
  gridcontainer: {
    alignContent: 'center'
  },
  items: {
    margin: 0,
    width: '100%'
  },
  avatar: {
    margin: theme.spacing(1),
    backgroundColor: theme.palette.secondary.main,
    width: 192,
    height: 192
  },
  form: {
    width: '50%',
    marginTop: theme.spacing(1),
    backgroundColor: 'transparent',
    alignContent: 'center',
    borderRadius: "20px",
  },
  submit: {
    margin: theme.spacing(3, 0, 2),
  },
  rootRtl: {
    "& label": {
      right: 10,
      left: "auto",
      paddingRight: 20,
      color: "var(--text-secondary)"
    },
    "& legend": {
      textAlign: "right",
      marginRight: 20
    },
    "& label.Mui-focused": {
      color: 'var(--primary)',
    },
    "& .MuiInput-underline:after": {
      borderBottomColor: "#E9AE31",
    },
    "& .MuiFilledInput-underline:after": {
      borderBottomColor: "#E9AE31",
    },
    "& .MuiOutlinedInput-root": {
      "& fieldset": {
        borderColor: "var(--border-color)",
      },
      "&.Mui-focused fieldset": {
        borderColor: "#E9AE31",
      },
      "& input": {
        color: "var(--text-main)"
      }
    },
  },
  rootRtl_1: {
    "& label": {
      right: 15,
      left: "auto",
      paddingRight: 25,
      color: "var(--text-secondary)"
    },
    "& legend": {
      textAlign: "right",
      marginRight: 25
    },
    "& label.Mui-focused": {
      color: 'var(--primary)',
    },
    "& .MuiInput-underline:after": {
      borderBottomColor: "#E9AE31",
    },
    "& .MuiFilledInput-underline:after": {
      borderBottomColor: "#E9AE31",
    },
    "& .MuiOutlinedInput-root": {
      "& fieldset": {
        borderColor: "var(--border-color)",
      },
      "&.Mui-focused fieldset": {
        borderColor: "#E9AE31",
      },
      "& input": {
        color: "var(--text-main)"
      }
    },
  },
  rootRtl_2: {
    "& label": {
      right: 10,
      left: "auto",
      paddingRight: 12,
      color: "var(--text-secondary)"
    },
    "& legend": {
      textAlign: "right",
      marginRight: 25
    },
    "& label.Mui-focused": {
      color: 'var(--primary)',
    },
    "& .MuiInput-underline:after": {
      borderBottomColor: "#E9AE31",
    },
    "& .MuiFilledInput-underline:after": {
      borderBottomColor: "#E9AE31",
    },
    "& .MuiOutlinedInput-root": {
      "& fieldset": {
        borderColor: "var(--border-color)",
      },
      "&.Mui-focused fieldset": {
        borderColor: "#E9AE31",
      },
      "& input": {
        color: "var(--text-main)"
      }
    },
  },
  right: {
    "& legend": {
      marginRight: 30
    },
  },
  rightStorelink: {
    "& legend": {
      marginRight: 25
    },
  },
  title: {
    color: 'var(--text-main)',
    marginBottom: '15px',
    paddingTop: '15px',
    paddingLeft: '15px',
    fontSize: '20px',
    fontWeight: "700"
  },
  buttonStyle: {
    margin: 0,
    width: '100%',
    height: 50,
    borderRadius: "10px",
    background: 'linear-gradient(135deg, #E9AE31 0%, #C58F1F 100%)',
    color: '#000',
    fontWeight: "bold",
    '&:hover': {
      background: 'linear-gradient(135deg, #F0C35B 0%, #D8A535 100%)',
    }
  },
  textField: {
    "& label": {
      color: 'var(--text-secondary)'
    },
    "& label.Mui-focused": {
      color: 'var(--primary)',
    },
    "& .MuiInput-underline:after": {
      borderBottomColor: "#E9AE31",
    },
    "& .MuiFilledInput-underline:after": {
      borderBottomColor: "#E9AE31",
    },
    "& .MuiOutlinedInput-root": {
      "& fieldset": {
        borderColor: "var(--border-color)",
      },
      "&.Mui-focused fieldset": {
        borderColor: "#E9AE31",
      },
      "& input": {
        color: "var(--text-main)"
      }
    },
  },
  selectField: {
    color: "var(--text-main)",
    "&.Mui-focused .MuiOutlinedInput-notchedOutline": {
      borderColor: "#E9AE31",
    },
    "& .MuiOutlinedInput-notchedOutline": {
      borderColor: "var(--border-color)",
    },
  },
}));

const SmsSettings = (props) => {
  const { t, i18n } = useTranslation();
  const isRTL = i18n.dir();
  const {
    editSmsConfig,
    editSettings
  } = api;
  const settings = useSelector(state => state.settingsdata.settings);
  const smsDetails = useSelector(state => state.smsconfigdata.smsDetails)
  const classes = useStyles();
  const [data, setData] = useState();
  const [customMobileOTP, setCustomMobileOTP] = useState(false);
  const dispatch = useDispatch();

  useEffect(() => {
    if (smsDetails) {
      setData(smsDetails);
    } else {
      setData({
        apiUrl: "",
        method: "",
        authorization: "",
        contentType: "",
        body: ""
      })
    }
  }, [smsDetails]);

  useEffect(() => {
    if (settings && settings.customMobileOTP) {
      setCustomMobileOTP(true);
    } else {
      setCustomMobileOTP(false);
    }
  }, [settings]);

  const handleSubmit = (e) => {
    if (settings.AllowCriticalEditsAdmin) {
      dispatch(editSmsConfig(data));
      dispatch(editSettings({ ...settings, customMobileOTP: customMobileOTP }));
    } else {
      alert(t('demo_mode'));
    }
  }

  return (
    <form className={classes.form}>
      <style>{`
          .MuiFormControlLabel-label {
            color: var(--text-main) !important;
          }
            .MuiSwitch-colorPrimary.Mui-checked {
            color: #E9AE31 !important;
          }
          .MuiSwitch-colorPrimary.Mui-checked + .MuiSwitch-track {
            background-color: #E9AE31 !important;
          }
        `}</style>
      <Grid item xs={12} sm={12} md={12} lg={12}>
        <Grid item xs={12}>
          <Typography component="h1" variant="h5" className={classes.title} style={{ textAlign: isRTL === 'rtl' ? 'right' : 'left' }}>
            {t('smssettings_title')}
          </Typography>
        </Grid>
        <div className={classes.container1}>
          <Grid container spacing={2} style={{ direction: isRTL === 'rtl' ? 'rtl' : 'ltr' }} >
            <Grid item xs={12} sm={12} md={12} lg={12}>
              <TextField
                className={isRTL === "rtl" ? classes.rootRtl : classes.textField}
                variant="outlined"
                margin="normal"
                required
                fullWidth
                id="apiUrl"
                label={t('apiUrl')}
                name="apiUrl"
                autoComplete="apiUrl"
                onChange={(e) => setData({ ...data, apiUrl: e.target.value })}
                value={settings.AllowCriticalEditsAdmin ? (data && data.apiUrl ? data.apiUrl : "") : "Hidden for Demo"}
              />
              <TextField
                className={isRTL === "rtl" ? classes.rootRtl : classes.textField}
                variant="outlined"
                margin="normal"
                required
                fullWidth
                id="method"
                label={t('method')}
                name="method"
                autoComplete="method"
                onChange={(e) => setData({ ...data, method: e.target.value })}
                value={settings.AllowCriticalEditsAdmin ? (data && data.method ? data.method : "") : "Hidden for Demo"}
              />
              <TextField
                className={isRTL === "rtl" ? classes.rootRtl : classes.textField}
                variant="outlined"
                margin="normal"
                fullWidth
                id="authorization"
                label={t('authorization')}
                name="authorization"
                autoComplete="authorization"
                onChange={(e) => setData({ ...data, authorization: e.target.value })}
                value={settings.AllowCriticalEditsAdmin ? (data && data.authorization ? data.authorization : "") : "Hidden for Demo"}
              />
              <TextField
                className={isRTL === "rtl" ? classes.rootRtl : classes.textField}
                variant="outlined"
                margin="normal"
                fullWidth
                id="contentType"
                label={t('contentType')}
                name="contentType"
                autoComplete="contentType"
                onChange={(e) => setData({ ...data, contentType: e.target.value })}
                value={settings.AllowCriticalEditsAdmin ? (data && data.contentType ? data.contentType : "") : "Hidden for Demo"}
              />
              <TextField
                className={isRTL === "rtl" ? classes.rootRtl : classes.textField}
                variant="outlined"
                margin="normal"
                fullWidth
                id="body"
                label={t('body')}
                name="body"
                autoComplete="body"
                onChange={(e) => setData({ ...data, body: e.target.value })}
                value={settings.AllowCriticalEditsAdmin ? (data && data.body ? data.body : "") : "Hidden for Demo"}
              />
              <FormControlLabel
                style={{ flexDirection: isRTL === 'rtl' ? 'row' : 'row-reverse', paddingTop: 10, paddingBottom: 15, marginLeft: 5 }}
                label={t('customMobileOTP')}
                control={
                  <Switch
                    checked={customMobileOTP}
                    onChange={(e) => setCustomMobileOTP(e.target.checked)}
                    name="customMobileOTP"
                    color="primary"
                  />
                }
              />
              <Button
                size="lg"
                onClick={handleSubmit}
                variant="contained"
                color="secondaryButton"
                className={classes.buttonStyle}
              >
                {t('submit')}
              </Button>
            </Grid>
          </Grid>
        </div>
      </Grid>
    </form>
  );

}

export default SmsSettings;